import { AfterContentInit, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from '../../data-services/auth.service';
import { AsyncPipe } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { selectAllEventSystems } from '../../data-services/stores/selectors/event-systems.selectors';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-reset-password',
    imports: [RouterModule, AsyncPipe, FormsModule,ReactiveFormsModule,PasswordModule],
    templateUrl: '../ui/reset-password.component.html',
    styleUrl: '../ui/reset-password.component.css',
})
export class ResetPasswordComponent implements AfterContentInit, OnInit{
    private readonly _store = inject(Store);
    private readonly _authService = inject(AuthService);
    private readonly _route = inject(ActivatedRoute);
    private readonly _titleService = inject(Title)
    eventSystems$ = this._store.select(selectAllEventSystems);
    resetEmailControl = new FormControl('', [Validators.email, Validators.required]);
    resetPassword = new FormControl('', [Validators.required]);
    resetPasswordConfirm = new FormControl('', [Validators.required]);
    resetCode = new FormControl('', [Validators.required]);
    code?: string = this._route.snapshot.queryParams['code'];
    email?: string = this._route.snapshot.queryParams['email'];

    requestPasswordReset() {
        if (this.code) {
            this._authService.requestPasswordReset(this.resetEmailControl.value!).subscribe(
                response => {
                    if (response) {
                    
                    }
                    else {
                    
                    }
                }
            )
        }
        else {
            this._authService.passwordReset(this.resetEmailControl.value!, this.resetCode.value!, this.resetPassword.value!);
        }
    }

    ngOnInit(): void {
        this._titleService.setTitle('LRPTickets.co.uk | Request password reset')
    }

    ngAfterContentInit(): void {
        if (this.email) {
            this.resetEmailControl.setValue(this.email);
            this.resetEmailControl.disable();
        }
        if (this.code) {
            this.resetCode.setValue(this.code);
            this.resetCode.disable();
        }
    }
}
